import React from "react";
import PageForm from "../form";

const PrivacyPolicy = ({ group }: { group: string }) => {
  return <PageForm title="Privacy Policy" Key={`${group}-privacy-policy`} />;
};

export default PrivacyPolicy;
